import { Directive, ElementRef, Input, OnInit } from '@angular/core'
import { Angular2TokenService, UserData } from 'angular2-token'

export interface PolicyCheck {
  name: string,
  action: string,
}

@Directive({
  selector: '[policyCheck]'
})
export class PolicyCheckDirective implements OnInit {
  constructor(
    private el: ElementRef,
    private _tokenService: Angular2TokenService) {
  }

  @Input() policyCheck: PolicyCheck
  private policies: any = {}

  ngOnInit() {
    if (this._tokenService.currentUserData) {
      this.policies = this._tokenService.currentUserData['policies']

      if (this.policies[this.policyCheck.name]
        && this.policies[this.policyCheck.name].includes(this.policyCheck.action)) {
        this.el.nativeElement.style.display = 'block'
      } else {
        this.el.nativeElement.style.display = 'none'
      }
    } else {
      this.el.nativeElement.style.display = 'none'
    }
  }
}



// WEBPACK FOOTER //
// /Users/jason/src/matrix/client/src/app/policy-check.directive.ts